import React from 'react';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';

// eslint-disable-next-line react/jsx-filename-extension
const MaskedInputComponent = (props) => (<MaskedInput {...props} ref={props?.innerref} innerref={undefined} />);

const Input = styled(MaskedInputComponent)`
        position: relative;
        width: 100%;
        padding: 11px 16px 10px 16px;
        background: #ffffff !important;
        border: 1px solid ${(props) => (props.error ? '#B12A31' : 'rgb(217, 217, 217)')};
        border-radius: 5px;
        font-weight: 300;
        font-style: normal;
        font-size: 16px !important;
        line-height: 21px;
        letter-spacing: 1px !important;
        color: #1A1A1A !important;
        opacity: ${(props) => (props.disabled ? '0.4' : 'none')};
        &::placeholder {
            color: #B8C0C2;
        }
        &:-ms-input-placeholder {
            color: #B8C0C2;
        }
        &::-ms-input-placeholder {
            color: #B8C0C2;
        }
        &:focus {
            outline: 0;
        }
        &:-webkit-autofill {
            -webkit-box-shadow: inset 0 0 0 50px #ffffff !important;
        }
        &[data-success='true'] {
          padding: 11px 30px 10px 16px;
        }
`;

export { Input };
